import { createContext } from "react";

interface IDrawerThemeContext {
    drawerTheme: string;
    setDrawerTheme: any;
}

const DrawerThemeContext = createContext<IDrawerThemeContext>(null!);

export default DrawerThemeContext;